import { navigationTokens } from '@peritasai/ui-shared';

export const DRAWER_WIDTH = 200; // 12.5rem
export const DRAWER_WIDTH_COLLAPSED = 72; // 4.5rem
export const SIDEBAR_BG_COLOR = navigationTokens.surface;
